export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";